import React from 'react';
import './ProductSection.css';


import productImage from '../assets/images/ebizcard_product.png';

const ProductSection = () => {
  return (
    <section id="products" className="product-section">
      <h2>Our Product</h2>
      <div className="product-card">
        <div className="product-info">
          <h3>EbizCard</h3>
          <p>
            Create stunning, professional e-business cards in minutes, customized to reflect your personal brand.
            Share your contact information effortlessly with QR codes or NFC, and never worry about running out of cards again.
          </p>
          <a href="#learn-more" className="product-link">Find out more →</a>
        </div>
        <img src={productImage} alt="EbizCard" className="product-image" />
      </div>
    </section>
  );
};

export default ProductSection;
